import { MouseEvent } from "react";
import {
  SortButton,
  HeaderCell as GridHeaderCell,
  HeaderCellActions,
  HeaderCellTitle,
  HeaderCellCheckbox,
  CheckedState,
} from "@bst/react-ui";
import { CalculatedColumn, RenderHeaderCellProps } from "@bst/react-data-grid";
import { UserDTO, UserExistingRolesResponseDTO } from "../../../apiclients/bstinsights";
import { FilterType } from '../../../apiclients/api/types/FilterType';

import { CellRoleFilter } from './CellRoleFilter';
import { ColumnMenuTrigger } from "./ColumnMenuTrigger";
import { CellDropdownFilter } from './CellDropdownFilter';
import { USER_ROLES } from '../../../stores/UserManagement/constants';

type Props = {
  checked?: CheckedState;
  columnKey: string;
  filterType?: FilterType
  columnMenuActive?: boolean;
  onToggleSort?: () => void;
  toggleColumnMenu?: (column: CalculatedColumn<UserDTO>, event?: MouseEvent) => void;
  handleCheckedChange?: () => void;
  existingRolesCount?: UserExistingRolesResponseDTO
} & RenderHeaderCellProps<UserDTO>;

export function HeaderCell({
  column,
  checked,
  tabIndex,
  columnKey,
  filterType,
  sortDirection,
  columnMenuActive,
  onToggleSort,
  toggleColumnMenu,
  handleCheckedChange,
  existingRolesCount
}: Props) {
  return (
    <GridHeaderCell tabIndex={tabIndex}>
      {column.frozen && (
        <HeaderCellCheckbox
          checked={checked}
          onCheckedChange={handleCheckedChange}
          data-testid="select-all-checkbox"
          style={{ display: 'none' }}
        />
      )}
      <HeaderCellTitle>{column.name}</HeaderCellTitle>
      <HeaderCellActions>
        <ColumnMenuTrigger
          dataTestid={`column-menu-trigger-${column.key}`}
          columnMenuActive={columnMenuActive}
          toggleColumnsMenu={(event) => toggleColumnMenu?.(column, event)}
        />
        {filterType === FilterType.AutoComplete && (
          <CellDropdownFilter
            column={column}
            columnKey={columnKey}
          />
        )}
        {USER_ROLES[columnKey] && (
          <CellRoleFilter
            column={column}
            columnKey={columnKey}
            existingRolesCount={existingRolesCount}
          />
        )}
        <SortButton
          direction={sortDirection}
          onToggleSort={() => onToggleSort?.()}
          data-testid={`sort-button-${column.key}`}
        />
      </HeaderCellActions>
    </GridHeaderCell>
  );
}
